import styled from 'styled-components';
import { colors } from '../colors';

interface tableRowProps {
	width?: string;
	projectDocDetails?: boolean;
	usageDetails?: boolean;
}

const TableRow = styled.tr<tableRowProps>`
	width: 100%;
	border-collapse: collapse;
	border-spacing: 0px;
	box-shadow: inset 0px -1px 0px ${colors.GreyE1};
	th {
		width: ${({ width }) => width}!important;
		text-align: left;
	}
	${({ projectDocDetails }) =>
		projectDocDetails &&
		`box-shadow: none;
		label,p{
			font-size: 13px;
			line-height: 19px;
			color: ${colors.Black};
		}
		label{
			color: ${colors.Grey58};
		}
		td{
			padding:16px;
		}
	`}
	${({ usageDetails }) =>
		usageDetails &&
		`box-shadow: none;
		label,p{
			font-size: 13px;
			line-height: 19px;
			color: ${colors.Black};
		}
		label{
			color: ${colors.Grey58};
		}
		td {
			padding:8px 15px;
		}
	`}
`;

export default TableRow;
